/**
 * @author <ziad.khoury.hanna@oceandatalab.com>
 * @flow
 */
import {html} from 'htm/preact';
import {RelativeLink as Link} from './RelativeLink.js';
/*:: import type {SeashotVisibility} from '../api.js'; */

/*:: type Props = {
  +tags: string[],
  +seashotVisibility: SeashotVisibility,
}; */

function locationForTag(tag /*: string */) {
  return (location) => ({
    ...location,
    pathname: `/t/${tag}`,
  });
}

function VisibilityTag({visibility} /*: {+visibility: SeashotVisibility} */) {
  // if (visibility === 'public') {
  //   return null;
  // }
  const label = visibility === 'unpublished' ? 'draft' : visibility;
  return html`<li className=${`tag -visibility`}>${label}</li>`;
}

function Tag({tag} /*: {+tag: string} */) {
  return html`<li className="tag" title=${tag}>
    <${Link} to=${locationForTag(tag)}>${tag}</${Link}>
  </li>`;
}

export function Tags({tags, seashotVisibility} /*: Props */) /*: React$Node */ {
  return html`
    <ul className="tags">
      <${VisibilityTag} visibility=${seashotVisibility} />
      ${tags.map((tag) => html`<${Tag} key=${tag} tag=${tag} />`)}
    </ul>
  `;
}
